module.exports = __webpack_public_path__ + "img/wallet-interest-none.0ffb94b1.svg";